
export class RouteInfo {
  routeelement: string;
  routepath: string;
  routedata: any;
}
